import React, { useState, useEffect } from "react";
import styles from "./Subscribenewsletter.module.css";
import { SubscribeMail } from "../../controller/Images";
import Buttons from "../../components/buttons/Buttons";
import { motion } from "framer-motion";
import ModalComponent from "../../components/modalcomponent/ModalComponent";
import { AxiosInstance } from "../../axios/index"; // ✅ ensure AxiosInstance is correctly imported

const leftVariant = {
  hidden: { opacity: 0, x: -100 },
  visible: {
    opacity: 1,
    x: 0,
    transition: {
      duration: 1.2,
      delay: 0.3,
    },
  },
};

const rightVariant = {
  hidden: { opacity: 0, x: 100 },
  visible: {
    opacity: 1,
    x: 0,
    transition: {
      duration: 1.2,
      delay: 0.3,
    },
  },
};

const Subscribenewsletter = ({ noPadding = false }) => {
  const [email, setEmail] = useState("");
  const [subscribed, setSubscribed] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [modalMessage, setModalMessage] = useState({ title: "", body: "" });
  const [emailError, setEmailError] = useState("");

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth < 768);
    };
    checkMobile();
    window.addEventListener("resize", checkMobile);
    return () => window.removeEventListener("resize", checkMobile);
  }, []);

  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  const handleSubscribe = async (e) => {
    e.preventDefault();
    setEmailError("");

    if (!email.trim()) {
      setEmailError("Email cannot be empty.");
      return;
    }

    if (!emailRegex.test(email)) {
      setEmailError("Please enter a valid email address.");
      return;
    }

    try {
      const response = await AxiosInstance.post("/api/subscribenow/create", {
        email,
      });

      const data = response.data;

      if (response.status === 200 && data.status) {
        setSubscribed(true);
        setModalMessage({
          title: "Subscription Successful!",
          body: "Thank you for subscribing to the Bharat Clouds newsletter you’ll now receive updates on insightful blogs, exciting job openings, and key announcements. Stay connected!",
        });
        setOpenModal(true);
      } else {
        setModalMessage({
          title: "Subscription Failed",
          body: data.message || "Something went wrong. Please try again.",
        });
        setOpenModal(true);
      }
    } catch (error) {
      console.error("Error subscribing:", error);
      setModalMessage({
        title: "Subscription Error",
        body: "Could not connect to the server. Please check your internet connection and try again.",
      });
      setOpenModal(true);
    }
  };

  const handleModalClose = () => {
    setOpenModal(false);
    setEmail("");
    setSubscribed(false);
  };

  return (
    <div
      className={`container-fluid ${styles.newsletterContainer} ${
        noPadding ? "" : styles.newsletterPadding
      }`}
      style={{ maxWidth: "1480px", margin: "0 auto" }}
    >
      <div className={`row p-0 m-0 ${styles.newsletter_responsive}`}>
        {/* Left Column */}
        {isMobile ? (
          <div className="col-12 col-md-7">
            <div
              className={`card-body text-center py-5 ${styles.newsletterBox}`}
            >
              <h5 className={`main_heading ${styles.newsletterHeading}`}>
                Subscribe to Our Newsletter
              </h5>
              <p className={`main_subheading ${styles.newsletterDescription}`}>
                Stay updated with the latest news, insights, and updates from
                Bharat Clouds
              </p>

              {!subscribed ? (
                <form className="mt-5" onSubmit={handleSubscribe}>
                  <div className={` ${styles.Email_box}`}>
                    <input
                      type="email"
                      className={`form-control form-control-lg rounded-3 ${
                        emailError ? "is-invalid" : ""
                      }`}
                      placeholder="Enter your email"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      required
                    />
                    {emailError && (
                      <div className="invalid-feedback">{emailError}</div>
                    )}
                  </div>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      borderRadius: "10px",
                    }}
                  >
                    <Buttons type="submit" text="Subscribe Now" />
                  </div>
                </form>
              ) : (
                <div className={styles.successMessage}>
                  Processing your subscription...
                </div>
              )}
            </div>
          </div>
        ) : (
          <motion.div
            className="col-12 col-md-7"
            variants={leftVariant}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: false, amount: 0.3 }}
          >
            <div
              className={`card-body text-center py-5 ${styles.newsletterBox}`}
            >
              <h5 className={`main_heading ${styles.newsletterHeading}`}>
                Subscribe to Our Newsletter
              </h5>
              <p className={`main_subheading ${styles.newsletterDescription}`}>
                Stay updated with the latest news, insights, and updates from
                Bharat Clouds
              </p>

              {!subscribed ? (
                <form className="mt-5" onSubmit={handleSubscribe}>
                  <div className={`mb-3 ${styles.Email_box}`}>
                    <input
                      type="email"
                      className={`form-control form-control-lg rounded-3 ${
                        emailError ? "is-invalid" : ""
                      }`}
                      placeholder="Enter your email"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      required
                    />
                    {emailError && (
                      <div className="invalid-feedback">{emailError}</div>
                    )}
                  </div>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      borderRadius: "10px",
                    }}
                  >
                    <Buttons type="submit" text="Subscribe Now" />
                  </div>
                </form>
              ) : (
                <div className={styles.successMessage}>
                  Processing your subscription...
                </div>
              )}
            </div>
          </motion.div>
        )}

        {/* Right Column */}
        {isMobile ? (
          <div className="col-12 col-md-5 d-flex justify-content-center align-items-center">
            <img
              src={SubscribeMail}
              alt="Subscribe Illustration"
              className={styles.customImage}
              loading="eager"
            />
          </div>
        ) : (
          <motion.div
            className="col-12 col-md-5 d-flex justify-content-center align-items-center"
            variants={rightVariant}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: false, amount: 0.3 }}
          >
            <motion.img
              src={SubscribeMail}
              alt="Subscribe Illustration"
              className={styles.customImage}
              initial={{ opacity: 0, scale: 0.95 }}
              animate={{ opacity: 1, scale: 1 }}
              transition={{ duration: 1.2, ease: "easeOut" }}
              loading="eager"
            />
          </motion.div>
        )}
      </div>

      {/* Modal */}
      <ModalComponent
        show={openModal}
        onHide={handleModalClose}
        title={modalMessage.title}
        bodyText={modalMessage.body}
        buttontext="OK"
      />
    </div>
  );
};

export default Subscribenewsletter;
